module.exports = __webpack_public_path__ + "img/trinidadandtobago.659bb19a.svg";